import { CustomerAccountPage } from "@/components/CustomerPage";
import { InternalTextLink } from "@/components/Links";
import { CMP_SIGNIN_URL, LOGIN_URL } from "@/core/urls";
import useDocTitle from "@/hooks/use-doc-title";
import B2CHeader from "@/tpo/header/B2CHeader";

function ResetCompletePage({ partners }) {
  useDocTitle("Reset password complete");
  return (
    <>
      <B2CHeader />
      <CustomerAccountPage
        jumbotronProps={{
          title: "Password reset complete",
          bg: partners ? "partners" : "purple",
          color: partners ? "dark" : "white"
        }}
      >
        Your password has been successfully reset. Please click{" "}
        <InternalTextLink href={partners ? CMP_SIGNIN_URL : LOGIN_URL}>here</InternalTextLink> to
        login.
      </CustomerAccountPage>
    </>
  );
}

export default ResetCompletePage;
